import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { store } from './store'
import Dialog from './components/Shared/Dialog.vue'
import * as firebase from 'firebase'
import './registerServiceWorker'

import VueFilter from 'vue-filter';
Vue.use(VueFilter);

require('../node_modules/chartist/dist/chartist.css');

import TransactionDialog from './components/Shared/Transactions.vue'
import UpdateDialog from './components/Shared/Update.vue'

Vue.use(Vuetify, {
  theme: {
    primary: '#0055D4',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#ff0000',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.component('dialog-component', Dialog);
Vue.component('transactions-dialog', TransactionDialog);
Vue.component('update-dialog', UpdateDialog);


Vue.config.productionTip = false

Vue.use(require('vue-chartist'))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created() {
    firebase.initializeApp({
      apiKey: 'AIzaSyCryA_hiHOfU1c7R7AA8t-jOcxLy1BGtw0',
      authDomain: 'savings-app-c682e.firebaseapp.com',
      databaseURL: 'https://savings-app-c682e.firebaseio.com',
      projectId: 'savings-app-c682e'
    })

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.dispatch('outsideAuth', true)
        this.$router.push({ name: 'welcome' })
      } else {
        this.$store.dispatch('outsideAuth', false)
        this.$router.push({ name: 'logoPage' })
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js